---
title: "Как посчитать символы в тексте и не отдать черновик наружу"
description: "Сценарий для SEO title, описаний, интерфейсных строк и постов с лимитами: считаем символы локально в браузере."
locale: "ru"
date: "2026-06-21"
tags: ["счётчик символов", "seo", "локально"]
relatedTools: ["textCounter"]
translations:
  en: "how-to-count-characters-in-text"
faq:
  - q: "Текст отправляется на сервер?"
    a: "Нет. Счётчик работает в браузере, а введённый текст не уходит в сеть."
  - q: "Можно ли считать emoji и составные символы?"
    a: "Да. В современных браузерах используется Intl.Segmenter, поэтому видимые символы считаются ближе к тому, как их видит человек."
---

SEO title на 82 символа выглядит нормально в таблице, но в сниппете уже
обрезается. Описание на 210 символов тоже можно отправить, только потом
его перережет поисковик. Для таких мелочей не нужен аккаунт, облачный
редактор или сервис, который принимает ваш черновик на сервер.

Откройте [счётчик символов](/schetchik-simvolov), вставьте текст и сразу
смотрите символы, слова, строки, абзацы и размер UTF-8. Это обычная
браузерная операция: строка лежит в памяти вкладки, расчёт идёт на
клиенте, сетевого запроса с вашим текстом нет.

## Где счётчик особенно полезен

У SEO title и description лимиты плавающие: поисковик режет не только по
числам, но числа всё равно нужны как грубый контроль. В интерфейсных
строках другая боль: перевод на английский или русский внезапно ломает
кнопку, потому что строка стала длиннее на 30 процентов. В постах и
формах лимит обычно жёсткий, и проще поймать его до публикации.

Отдельный случай - UTF-8 размер. Один emoji может занимать больше одного
байта, кириллица тоже не равна ASCII. Если поле в API или CMS ограничено
байтами, одного визуального подсчёта мало.

## Почему локально лучше

Текстовые черновики часто выглядят безобидно, пока в них не окажется
имя клиента, кусок договора, пароль из логов или фрагмент внутреннего
интерфейса. Privacy policy можно написать красиво, но вкладка Network
проверяется быстрее. У txtify счётчик не отправляет содержимое поля.

Для одного короткого заголовка это вопрос удобства. Для рабочих черновиков
это уже нормальная гигиена.
